import {useState, useEffect} from 'react';

export function useCountdown(
  initialSeconds: number,
  onCountdownEnd: () => void,
) {
  const [seconds, setSeconds] = useState(initialSeconds);
  const [isActive, setIsActive] = useState(true);

  useEffect(() => {
    if (!isActive) {
      return;
    }

    if (seconds === 0) {
      onCountdownEnd();
      setIsActive(false); // eslint-disable-line react-hooks/set-state-in-effect
      return;
    }

    const interval = setInterval(() => {
      setSeconds((prev) => prev - 1);
    }, 1000);

    return () => clearInterval(interval);
  }, [seconds, isActive, onCountdownEnd]);

  const reset = (newSeconds: number) => {
    setSeconds(newSeconds);
    setIsActive(true);
  };

  const pause = () => {
    setIsActive(false);
  };

  const resume = () => {
    setIsActive(true);
  };

  return {seconds, reset, pause, resume};
}
